import i18n from '@/utils/i18n';
import React from 'react';
import { AdyenDropinWrapper } from '@/components/payments/adyen-dropin-wrapper';
import { APP_MODAL_ROUTES, ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import {
  AppModalStackParams,
  OrderInboundsStackParams,
} from '@/navigators/types';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';

// Registered in both the app modal stack and the order agent stack, which
// cannot reach each other.
type Props =
  | StackScreenProps<AppModalStackParams, APP_MODAL_ROUTES.AddPaymentMethod>
  | StackScreenProps<
      OrderInboundsStackParams,
      ORDER_INBOUNDS_ROUTES.AddPaymentMethod
    >;

export const AddPaymentMethodScreen: React.FC<Props> = ({ route }) => {
  const {
    onAddUnsavedPaymentMethod,
    onBackPress,
    onSavePaymentMethod,
    requireSavedPaymentMethod = false,
    transactionFeeMap,
  } = route.params;
  const { goBack } = useNavigation();

  return (
    <ModalContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: () => {
          onBackPress?.();
          goBack();
        },
        showShadow: true,
        title: i18n.t('add_payment_method'),
      }}
    >
      <AdyenDropinWrapper
        onAddUnsavedMethod={onAddUnsavedPaymentMethod}
        onSaveSuccess={onSavePaymentMethod}
        requireSavedPaymentMethod={requireSavedPaymentMethod}
        transactionFeeMap={transactionFeeMap}
      />
    </ModalContainer>
  );
};
